import { ContactVM } from "../back-office-admin-common/contact.models";
import { LocationBaseDTO, LocationFullDTO } from "../../../../shared/models/location.model";
import { CompanyReportDTO, CustomerFullDTO, GeneralFieldsDTO } from "./customer.model";
import { CreateOrEditUserDTO } from '../users/user.model';
import { PointOfSaleDetailVM } from '../point-of-sale/bo-point-of-sale.model';
import { PaymentTermsByChannelDTO } from '../back-office-admin-common/channel-payment-term.model';
import { FormGroup } from '@angular/forms';

export interface RegistrationCompletedPayload {
  success: boolean;
  customer?: CustomerFullDTO;
}

export class RegisterCustomerVM { //New registration model for customer
  billingLocation: LocationBaseDTO; 
  billingLocationContacts: ContactVM[];
  currentStoreId: number;
  customer: CustomerFullDTO;
  customerCategoryIds: number[];
  existingUserId?: number;
  financialReport: CompanyReportDTO;
  generalFieldIds: number[];
  paymentTermOverrides: PaymentTermsByChannelDTO[];
  pointsOfSales: PointOfSaleDetailVM[];
  sendToErp: boolean;
  user: CreateOrEditUserDTO;
  
  constructor(init?: Partial<RegisterCustomerVM>) {
    Object.assign(this, init);
  }
}

export class CustomerRegistrationPOS {
  name: string;
  useCustomerBillingLocation: boolean;
  location: LocationFullDTO;
  contacts: ContactVM[];

  constructor(init?: Partial<CustomerRegistrationPOS>) {
    Object.assign(this, init);
  }
}

export class UpdateFullCustomer {
  isCustomerChanged: boolean;
  generalFieldsToAdd: number[];
  generalFieldsToRemove: number[];
  newCustomer: CustomerFullDTO;
  oldCustomer: CustomerFullDTO;
  sendToErp: boolean;
  newGeneralFields: GeneralFieldsDTO[];
  tab: 'customer-info' | 'commercial-info' | 'financial-info'
  customerForm?: FormGroup;

  constructor(init?: Partial<UpdateFullCustomer>) {
    Object.assign(this, init);
  }
}
